import { LOGIN, LOGOUT, USER_DETAILS } from "../types";

const initialState = {
  user: JSON.parse(sessionStorage.getItem("user")) || {
    id: 11223344,
    name: "Logging in...",
    username: "undefined_user",
    email: "undefined_email",
    api_token: {
      sipUsername: "scott",
      sipPassword: "tiger",
    },
  },
  token: sessionStorage.getItem("token") || "",
  isLoggedIn: sessionStorage.getItem("user") ? true : false,
};

const authReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGIN:
      return {
        ...state,
        user: payload.user,
        token: payload.token,
        isLoggedIn: true,
      };
    case LOGOUT:
      return {
        ...state,
        user: {},
        token: "",
        isLoggedIn: false,
      };
    case USER_DETAILS:
      return {
        ...state,
        user: payload.user,
        token: payload.token,
        isLoggedIn: true,
      };
    default:
      return state;
  }
};

export default authReducer;
